import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import 'react-lazy-load-image-component/src/effects/blur.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { QuoteProvider } from './contexts/QuoteContext';
import CartSyncBridge from './contexts/CartSyncBridge';
import { CompareProvider } from './contexts/CompareContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QuoteProvider>
        <CompareProvider>
          <CartSyncBridge />
          <App />
        </CompareProvider>
      </QuoteProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
